import React from 'react';
import PropTypes from 'prop-types';
import ProgressBarStepper from './ProgressBarStepper';
import useProgressBarStepperFromTutorial from './useProgressBarStepperFromTutorial';

const ProgressBarStepperWrapper = ({ tutorial, stepsConditions, stepsCallbacks }) => {
  const { hook } = tutorial;
  const { steps, activeStep } = hook(stepsConditions, stepsCallbacks);
  const stepperData = useProgressBarStepperFromTutorial(steps, activeStep);
  return <ProgressBarStepper {...stepperData} />;
};

ProgressBarStepperWrapper.propTypes = {
  tutorial: PropTypes.shape({
    title: PropTypes.string,
    code: PropTypes.string.isRequired,
    hook: PropTypes.func.isRequired,
    completedText: PropTypes.string,
  }).isRequired,
  stepsConditions: PropTypes.arrayOf(PropTypes.bool).isRequired,
  stepsCallbacks: PropTypes.shape().isRequired,
};

export default ProgressBarStepperWrapper;
